import {
  DEFAULT_COL_LABEL,
  DEFAULT_ROW_LABEL,
} from 'sharedParts/config/blockConfig/constants';

import stubCollectionCount from '../components/questions/utils/stub/stubCollectionCount';

export default {
  options: stubCollectionCount(DEFAULT_ROW_LABEL),
  itemList: stubCollectionCount(DEFAULT_COL_LABEL),
};
